import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import store from '@/store'
import Events from '../views/Events.vue'
import Explore from '../views/Explore.vue'
import EpidemicPrevention from '../views/EpidemicPrevention.vue'
import VueMeta from 'vue-meta';
import BuildingGame from '../components/BuildingGame.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      langClrLg: 'black',
      langClrSm: 'black',
    }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      logoClr: 'white',
      langClrLg: 'black',
      langClrSm: 'black'
    }
  },
  {
    path: '/prevention',
    name: 'EpidemicPrevention',
    component: EpidemicPrevention,
    meta: {
      logoClr: 'white',
      menuClr: 'white',
      langClrLg: 'white',
      langClrSm: 'white',
    }
  },
  {
    path: '/events',
    name: 'Events',
    component: Events,
    meta: {
      logoClr: 'white',
      menuClr: 'white',
      langClrLg: 'white',
      langClrSm: 'white'
    }
  },
  {
    path: '/explore',
    name: 'Explore',
    component: Explore,
    meta: {
      langClrLg: 'black',
      langClrSm: 'black',
    }
  },
  {
    path: '/game',
    name: 'BuildingGame',
    component: BuildingGame,
    meta: {
      langClrLg: 'black',
      langClrSm: 'black',
    }
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  // if ()
  if (from.path == "/game" && to.path == "/") {
    console.log("back from game")
    store.commit("setPageDelay", 300);
    store.dispatch("triggerLoading", 1000);
  }
  setTimeout(() => {
    next()
    store.commit("setPageDelay", 10)
  }, store.state.pageDelay || 10)
})
export default router